import { Suspense } from 'react'
import { DataTableLoading } from '@/catalog-apps/components/component-library/DataTableComponent/DataTableLoading'
import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { SubscriptionsTable } from './SubscriptionsTable'

export function SubscriptionsHome() {
  return (
    <div className="px-5">
      {/* <PageHeader title="Subscriptions"></PageHeader> */}
      <QueryErrorBoundary errorMessage="Failed to fetch applications">
        <TablePageContainer fullHeight>
          <Suspense fallback={<DataTableLoading />}>
            <SubscriptionsTable />
          </Suspense>
        </TablePageContainer>
      </QueryErrorBoundary>
    </div>
  )
}
